/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type AggregateCategory = {
  __typename?: 'AggregateCategory';
  _count?: Maybe<CategoryCountAggregate>;
  _max?: Maybe<CategoryMaxAggregate>;
  _min?: Maybe<CategoryMinAggregate>;
};

export type AggregateMaterial = {
  __typename?: 'AggregateMaterial';
  _count?: Maybe<MaterialCountAggregate>;
  _max?: Maybe<MaterialMaxAggregate>;
  _min?: Maybe<MaterialMinAggregate>;
};

export type AggregateMaterialImportSheetRow = {
  __typename?: 'AggregateMaterialImportSheetRow';
  _avg?: Maybe<MaterialImportSheetRowAvgAggregate>;
  _count?: Maybe<MaterialImportSheetRowCountAggregate>;
  _max?: Maybe<MaterialImportSheetRowMaxAggregate>;
  _min?: Maybe<MaterialImportSheetRowMinAggregate>;
  _sum?: Maybe<MaterialImportSheetRowSumAggregate>;
};

export type AggregatePriceGroup = {
  __typename?: 'AggregatePriceGroup';
  _count?: Maybe<PriceGroupCountAggregate>;
  _max?: Maybe<PriceGroupMaxAggregate>;
  _min?: Maybe<PriceGroupMinAggregate>;
};

export type AggregateProductOptionsImportSheet = {
  __typename?: 'AggregateProductOptionsImportSheet';
  _count?: Maybe<ProductOptionsImportSheetCountAggregate>;
  _max?: Maybe<ProductOptionsImportSheetMaxAggregate>;
  _min?: Maybe<ProductOptionsImportSheetMinAggregate>;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum BulkImportStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type Category = {
  __typename?: 'Category';
  PriceSubGroup: Array<PriceSubGroup>;
  _count?: Maybe<CategoryCount>;
  composition: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materials: Array<Material>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  url: Scalars['String']['output'];
};


export type CategoryPriceSubGroupArgs = {
  cursor?: InputMaybe<PriceSubGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceSubGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceSubGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceSubGroupWhereInput>;
};


export type CategoryMaterialsArgs = {
  cursor?: InputMaybe<MaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialWhereInput>;
};

export type CategoryCount = {
  __typename?: 'CategoryCount';
  PriceSubGroup: Scalars['Int']['output'];
  materials: Scalars['Int']['output'];
};


export type CategoryCountPriceSubGroupArgs = {
  where?: InputMaybe<PriceSubGroupWhereInput>;
};


export type CategoryCountMaterialsArgs = {
  where?: InputMaybe<MaterialWhereInput>;
};

export type CategoryCountAggregate = {
  __typename?: 'CategoryCountAggregate';
  _all: Scalars['Int']['output'];
  composition: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  designer: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  shopifySessionId: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type CategoryCreateInput = {
  PriceSubGroup?: InputMaybe<PriceSubGroupCreateNestedManyWithoutCategoryInput>;
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<MaterialCreateNestedManyWithoutCategoryInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type CategoryCreateNestedOneWithoutMaterialsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutMaterialsInput>;
  create?: InputMaybe<CategoryCreateWithoutMaterialsInput>;
};

export type CategoryCreateNestedOneWithoutPriceSubGroupInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPriceSubGroupInput>;
  create?: InputMaybe<CategoryCreateWithoutPriceSubGroupInput>;
};

export type CategoryCreateOrConnectWithoutMaterialsInput = {
  create: CategoryCreateWithoutMaterialsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutPriceSubGroupInput = {
  create: CategoryCreateWithoutPriceSubGroupInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutMaterialsInput = {
  PriceSubGroup?: InputMaybe<PriceSubGroupCreateNestedManyWithoutCategoryInput>;
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type CategoryCreateWithoutPriceSubGroupInput = {
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<MaterialCreateNestedManyWithoutCategoryInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type CategoryMaxAggregate = {
  __typename?: 'CategoryMaxAggregate';
  composition?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CategoryMinAggregate = {
  __typename?: 'CategoryMinAggregate';
  composition?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CategoryNullableRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export type CategoryOrderByWithRelationInput = {
  PriceSubGroup?: InputMaybe<PriceSubGroupOrderByRelationAggregateInput>;
  composition?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designer?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  materials?: InputMaybe<MaterialOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  Composition = 'composition',
  CreatedAt = 'createdAt',
  Description = 'description',
  Designer = 'designer',
  Id = 'id',
  ShopifySessionId = 'shopifySessionId',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type CategoryUpdateInput = {
  PriceSubGroup?: InputMaybe<PriceSubGroupUpdateManyWithoutCategoryNestedInput>;
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  materials?: InputMaybe<MaterialUpdateManyWithoutCategoryNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CategoryUpdateOneRequiredWithoutPriceSubGroupNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutPriceSubGroupInput>;
  create?: InputMaybe<CategoryCreateWithoutPriceSubGroupInput>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutPriceSubGroupInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutPriceSubGroupInput>;
};

export type CategoryUpdateOneWithoutMaterialsNestedInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutMaterialsInput>;
  create?: InputMaybe<CategoryCreateWithoutMaterialsInput>;
  delete?: InputMaybe<CategoryWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<CategoryUpdateToOneWithWhereWithoutMaterialsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutMaterialsInput>;
};

export type CategoryUpdateToOneWithWhereWithoutMaterialsInput = {
  data: CategoryUpdateWithoutMaterialsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateToOneWithWhereWithoutPriceSubGroupInput = {
  data: CategoryUpdateWithoutPriceSubGroupInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpdateWithoutMaterialsInput = {
  PriceSubGroup?: InputMaybe<PriceSubGroupUpdateManyWithoutCategoryNestedInput>;
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CategoryUpdateWithoutPriceSubGroupInput = {
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  materials?: InputMaybe<MaterialUpdateManyWithoutCategoryNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CategoryUpsertWithoutMaterialsInput = {
  create: CategoryCreateWithoutMaterialsInput;
  update: CategoryUpdateWithoutMaterialsInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryUpsertWithoutPriceSubGroupInput = {
  create: CategoryCreateWithoutPriceSubGroupInput;
  update: CategoryUpdateWithoutPriceSubGroupInput;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  PriceSubGroup?: InputMaybe<PriceSubGroupListRelationFilter>;
  composition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designer?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  materials?: InputMaybe<MaterialListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type CategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  PriceSubGroup?: InputMaybe<PriceSubGroupListRelationFilter>;
  composition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designer?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<MaterialListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type CreateOnePriceGroupWithShopifyDefinitionInput = {
  priceSubGroupIds: Array<Scalars['String']['input']>;
  variantOptionValue: Scalars['String']['input'];
};

export type CreateVariantOptionWithShopifyDefinitionInput = {
  priceGroupIds: Array<Scalars['String']['input']>;
  productGqlId: Scalars['String']['input'];
  variantOptionName: Scalars['String']['input'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type EnumBulkImportStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<BulkImportStatus>;
};

export type EnumBulkImportStatusFilter = {
  equals?: InputMaybe<BulkImportStatus>;
  in?: InputMaybe<Array<BulkImportStatus>>;
  not?: InputMaybe<NestedEnumBulkImportStatusFilter>;
  notIn?: InputMaybe<Array<BulkImportStatus>>;
};

export type EnumProductOptionsImportStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ProductOptionsImportStatus>;
};

export type EnumProductOptionsImportStatusFilter = {
  equals?: InputMaybe<ProductOptionsImportStatus>;
  in?: InputMaybe<Array<ProductOptionsImportStatus>>;
  not?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  notIn?: InputMaybe<Array<ProductOptionsImportStatus>>;
};

export type EnumProductOptionsImportStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  _min?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  equals?: InputMaybe<ProductOptionsImportStatus>;
  in?: InputMaybe<Array<ProductOptionsImportStatus>>;
  not?: InputMaybe<NestedEnumProductOptionsImportStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProductOptionsImportStatus>>;
};

export type ImportJobCompletion = {
  __typename?: 'ImportJobCompletion';
  message: Scalars['String']['output'];
  totalFailedRows: Scalars['Float']['output'];
  totalImportedRows: Scalars['Float']['output'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
};

export type Material = {
  __typename?: 'Material';
  Category?: Maybe<Category>;
  MaterialImportSheetRow: Array<MaterialImportSheetRow>;
  _count?: Maybe<MaterialCount>;
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  metaObjectId: Scalars['String']['output'];
  previewImageId: Scalars['String']['output'];
  previewImageUrl: Scalars['String']['output'];
  priceSubGroupIds: Array<Scalars['String']['output']>;
  priceSubGroups: Array<PriceSubGroup>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MaterialCategoryArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type MaterialMaterialImportSheetRowArgs = {
  cursor?: InputMaybe<MaterialImportSheetRowWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialImportSheetRowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type MaterialPriceSubGroupsArgs = {
  cursor?: InputMaybe<PriceSubGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceSubGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceSubGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceSubGroupWhereInput>;
};

export type MaterialCount = {
  __typename?: 'MaterialCount';
  MaterialImportSheetRow: Scalars['Int']['output'];
  priceSubGroups: Scalars['Int']['output'];
};


export type MaterialCountMaterialImportSheetRowArgs = {
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type MaterialCountPriceSubGroupsArgs = {
  where?: InputMaybe<PriceSubGroupWhereInput>;
};

export type MaterialCountAggregate = {
  __typename?: 'MaterialCountAggregate';
  _all: Scalars['Int']['output'];
  categoryId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metaObjectId: Scalars['Int']['output'];
  previewImageId: Scalars['Int']['output'];
  previewImageUrl: Scalars['Int']['output'];
  priceSubGroupIds: Scalars['Int']['output'];
  shopifySessionId: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MaterialCreateManyCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  previewImageId: Scalars['String']['input'];
  previewImageUrl: Scalars['String']['input'];
  priceSubGroupIds?: InputMaybe<MaterialCreatepriceSubGroupIdsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialCreateManyCategoryInputEnvelope = {
  data: Array<MaterialCreateManyCategoryInput>;
};

export type MaterialCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MaterialCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MaterialCreateManyCategoryInputEnvelope>;
};

export type MaterialCreateNestedManyWithoutPriceSubGroupsInput = {
  connect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialCreateOrConnectWithoutPriceSubGroupsInput>>;
  create?: InputMaybe<Array<MaterialCreateWithoutPriceSubGroupsInput>>;
};

export type MaterialCreateOrConnectWithoutCategoryInput = {
  create: MaterialCreateWithoutCategoryInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialCreateOrConnectWithoutMaterialImportSheetRowInput = {
  create: MaterialCreateWithoutMaterialImportSheetRowInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialCreateOrConnectWithoutPriceSubGroupsInput = {
  create: MaterialCreateWithoutPriceSubGroupsInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialCreateWithShopifyInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uploadedFileId: Scalars['String']['input'];
};

export type MaterialCreateWithoutCategoryInput = {
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowCreateNestedManyWithoutAssociatedMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  previewImageId: Scalars['String']['input'];
  previewImageUrl: Scalars['String']['input'];
  priceSubGroups?: InputMaybe<PriceSubGroupCreateNestedManyWithoutMaterialsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialCreateWithoutMaterialImportSheetRowInput = {
  Category?: InputMaybe<CategoryCreateNestedOneWithoutMaterialsInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  previewImageId: Scalars['String']['input'];
  previewImageUrl: Scalars['String']['input'];
  priceSubGroups?: InputMaybe<PriceSubGroupCreateNestedManyWithoutMaterialsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialCreateWithoutPriceSubGroupsInput = {
  Category?: InputMaybe<CategoryCreateNestedOneWithoutMaterialsInput>;
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowCreateNestedManyWithoutAssociatedMaterialInput>;
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  previewImageId: Scalars['String']['input'];
  previewImageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialCreatepriceSubGroupIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type MaterialImportSheetRow = {
  __typename?: 'MaterialImportSheetRow';
  associatedMaterial?: Maybe<Material>;
  createdAt: Scalars['DateTimeISO']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  materialId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowNo: Scalars['Int']['output'];
  status: BulkImportStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type MaterialImportSheetRowAssociatedMaterialArgs = {
  where?: InputMaybe<MaterialWhereInput>;
};

export type MaterialImportSheetRowAvgAggregate = {
  __typename?: 'MaterialImportSheetRowAvgAggregate';
  rowNo?: Maybe<Scalars['Float']['output']>;
};

export type MaterialImportSheetRowCountAggregate = {
  __typename?: 'MaterialImportSheetRowCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  data: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  materialId: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  rowNo: Scalars['Int']['output'];
  shopifySessionId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MaterialImportSheetRowCreateManyAssociatedMaterialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rowNo: Scalars['Int']['input'];
  status?: InputMaybe<BulkImportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialImportSheetRowCreateManyAssociatedMaterialInputEnvelope = {
  data: Array<MaterialImportSheetRowCreateManyAssociatedMaterialInput>;
};

export type MaterialImportSheetRowCreateNestedManyWithoutAssociatedMaterialInput = {
  connect?: InputMaybe<Array<MaterialImportSheetRowWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialImportSheetRowCreateOrConnectWithoutAssociatedMaterialInput>>;
  create?: InputMaybe<Array<MaterialImportSheetRowCreateWithoutAssociatedMaterialInput>>;
  createMany?: InputMaybe<MaterialImportSheetRowCreateManyAssociatedMaterialInputEnvelope>;
};

export type MaterialImportSheetRowCreateOrConnectWithoutAssociatedMaterialInput = {
  create: MaterialImportSheetRowCreateWithoutAssociatedMaterialInput;
  where: MaterialImportSheetRowWhereUniqueInput;
};

export type MaterialImportSheetRowCreateWithoutAssociatedMaterialInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  data: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  rowNo: Scalars['Int']['input'];
  status?: InputMaybe<BulkImportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MaterialImportSheetRowListRelationFilter = {
  every?: InputMaybe<MaterialImportSheetRowWhereInput>;
  none?: InputMaybe<MaterialImportSheetRowWhereInput>;
  some?: InputMaybe<MaterialImportSheetRowWhereInput>;
};

export type MaterialImportSheetRowMaxAggregate = {
  __typename?: 'MaterialImportSheetRowMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowNo?: Maybe<Scalars['Int']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BulkImportStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MaterialImportSheetRowMinAggregate = {
  __typename?: 'MaterialImportSheetRowMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowNo?: Maybe<Scalars['Int']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BulkImportStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MaterialImportSheetRowOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MaterialImportSheetRowOrderByWithRelationInput = {
  associatedMaterial?: InputMaybe<MaterialOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  materialId?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  rowNo?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MaterialImportSheetRowScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  MaterialId = 'materialId',
  Message = 'message',
  RowNo = 'rowNo',
  ShopifySessionId = 'shopifySessionId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MaterialImportSheetRowScalarWhereInput = {
  AND?: InputMaybe<Array<MaterialImportSheetRowScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaterialImportSheetRowScalarWhereInput>>;
  OR?: InputMaybe<Array<MaterialImportSheetRowScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  materialId?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  rowNo?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumBulkImportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialImportSheetRowSumAggregate = {
  __typename?: 'MaterialImportSheetRowSumAggregate';
  rowNo?: Maybe<Scalars['Int']['output']>;
};

export type MaterialImportSheetRowUpdateInput = {
  associatedMaterial?: InputMaybe<MaterialUpdateOneWithoutMaterialImportSheetRowNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBulkImportStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialImportSheetRowUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBulkImportStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialImportSheetRowUpdateManyWithWhereWithoutAssociatedMaterialInput = {
  data: MaterialImportSheetRowUpdateManyMutationInput;
  where: MaterialImportSheetRowScalarWhereInput;
};

export type MaterialImportSheetRowUpdateManyWithoutAssociatedMaterialNestedInput = {
  connect?: InputMaybe<Array<MaterialImportSheetRowWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialImportSheetRowCreateOrConnectWithoutAssociatedMaterialInput>>;
  create?: InputMaybe<Array<MaterialImportSheetRowCreateWithoutAssociatedMaterialInput>>;
  createMany?: InputMaybe<MaterialImportSheetRowCreateManyAssociatedMaterialInputEnvelope>;
  delete?: InputMaybe<Array<MaterialImportSheetRowWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialImportSheetRowScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialImportSheetRowWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialImportSheetRowWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialImportSheetRowUpdateWithWhereUniqueWithoutAssociatedMaterialInput>>;
  updateMany?: InputMaybe<Array<MaterialImportSheetRowUpdateManyWithWhereWithoutAssociatedMaterialInput>>;
  upsert?: InputMaybe<Array<MaterialImportSheetRowUpsertWithWhereUniqueWithoutAssociatedMaterialInput>>;
};

export type MaterialImportSheetRowUpdateWithWhereUniqueWithoutAssociatedMaterialInput = {
  data: MaterialImportSheetRowUpdateWithoutAssociatedMaterialInput;
  where: MaterialImportSheetRowWhereUniqueInput;
};

export type MaterialImportSheetRowUpdateWithoutAssociatedMaterialInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumBulkImportStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialImportSheetRowUpsertWithWhereUniqueWithoutAssociatedMaterialInput = {
  create: MaterialImportSheetRowCreateWithoutAssociatedMaterialInput;
  update: MaterialImportSheetRowUpdateWithoutAssociatedMaterialInput;
  where: MaterialImportSheetRowWhereUniqueInput;
};

export type MaterialImportSheetRowWhereInput = {
  AND?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  NOT?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  OR?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  associatedMaterial?: InputMaybe<MaterialNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  materialId?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  rowNo?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumBulkImportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialImportSheetRowWhereUniqueInput = {
  AND?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  NOT?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  OR?: InputMaybe<Array<MaterialImportSheetRowWhereInput>>;
  associatedMaterial?: InputMaybe<MaterialNullableRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  rowNo?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumBulkImportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialListRelationFilter = {
  every?: InputMaybe<MaterialWhereInput>;
  none?: InputMaybe<MaterialWhereInput>;
  some?: InputMaybe<MaterialWhereInput>;
};

export type MaterialMaxAggregate = {
  __typename?: 'MaterialMaxAggregate';
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metaObjectId?: Maybe<Scalars['String']['output']>;
  previewImageId?: Maybe<Scalars['String']['output']>;
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MaterialMinAggregate = {
  __typename?: 'MaterialMinAggregate';
  categoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metaObjectId?: Maybe<Scalars['String']['output']>;
  previewImageId?: Maybe<Scalars['String']['output']>;
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MaterialNullableRelationFilter = {
  is?: InputMaybe<MaterialWhereInput>;
  isNot?: InputMaybe<MaterialWhereInput>;
};

export type MaterialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MaterialOrderByWithRelationInput = {
  Category?: InputMaybe<CategoryOrderByWithRelationInput>;
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowOrderByRelationAggregateInput>;
  categoryId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaObjectId?: InputMaybe<SortOrder>;
  previewImageId?: InputMaybe<SortOrder>;
  previewImageUrl?: InputMaybe<SortOrder>;
  priceSubGroupIds?: InputMaybe<SortOrder>;
  priceSubGroups?: InputMaybe<PriceSubGroupOrderByRelationAggregateInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MaterialScalarFieldEnum {
  CategoryId = 'categoryId',
  CreatedAt = 'createdAt',
  Id = 'id',
  MetaObjectId = 'metaObjectId',
  PreviewImageId = 'previewImageId',
  PreviewImageUrl = 'previewImageUrl',
  PriceSubGroupIds = 'priceSubGroupIds',
  ShopifySessionId = 'shopifySessionId',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type MaterialScalarWhereInput = {
  AND?: InputMaybe<Array<MaterialScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaterialScalarWhereInput>>;
  OR?: InputMaybe<Array<MaterialScalarWhereInput>>;
  categoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  previewImageId?: InputMaybe<StringFilter>;
  previewImageUrl?: InputMaybe<StringFilter>;
  priceSubGroupIds?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialUpdateManyWithWhereWithoutCategoryInput = {
  data: MaterialUpdateManyMutationInput;
  where: MaterialScalarWhereInput;
};

export type MaterialUpdateManyWithWhereWithoutPriceSubGroupsInput = {
  data: MaterialUpdateManyMutationInput;
  where: MaterialScalarWhereInput;
};

export type MaterialUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MaterialCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MaterialCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<MaterialUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<MaterialUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type MaterialUpdateManyWithoutPriceSubGroupsNestedInput = {
  connect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaterialCreateOrConnectWithoutPriceSubGroupsInput>>;
  create?: InputMaybe<Array<MaterialCreateWithoutPriceSubGroupsInput>>;
  delete?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaterialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  set?: InputMaybe<Array<MaterialWhereUniqueInput>>;
  update?: InputMaybe<Array<MaterialUpdateWithWhereUniqueWithoutPriceSubGroupsInput>>;
  updateMany?: InputMaybe<Array<MaterialUpdateManyWithWhereWithoutPriceSubGroupsInput>>;
  upsert?: InputMaybe<Array<MaterialUpsertWithWhereUniqueWithoutPriceSubGroupsInput>>;
};

export type MaterialUpdateOneWithoutMaterialImportSheetRowNestedInput = {
  connect?: InputMaybe<MaterialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaterialCreateOrConnectWithoutMaterialImportSheetRowInput>;
  create?: InputMaybe<MaterialCreateWithoutMaterialImportSheetRowInput>;
  delete?: InputMaybe<MaterialWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<MaterialUpdateToOneWithWhereWithoutMaterialImportSheetRowInput>;
  upsert?: InputMaybe<MaterialUpsertWithoutMaterialImportSheetRowInput>;
};

export type MaterialUpdateToOneWithWhereWithoutMaterialImportSheetRowInput = {
  data: MaterialUpdateWithoutMaterialImportSheetRowInput;
  where?: InputMaybe<MaterialWhereInput>;
};

export type MaterialUpdateWithShopifyDefinitionInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  uploadedFileId?: InputMaybe<Scalars['String']['input']>;
};

export type MaterialUpdateWithWhereUniqueWithoutCategoryInput = {
  data: MaterialUpdateWithoutCategoryInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialUpdateWithWhereUniqueWithoutPriceSubGroupsInput = {
  data: MaterialUpdateWithoutPriceSubGroupsInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialUpdateWithoutCategoryInput = {
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowUpdateManyWithoutAssociatedMaterialNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceSubGroups?: InputMaybe<PriceSubGroupUpdateManyWithoutMaterialsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialUpdateWithoutMaterialImportSheetRowInput = {
  Category?: InputMaybe<CategoryUpdateOneWithoutMaterialsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceSubGroups?: InputMaybe<PriceSubGroupUpdateManyWithoutMaterialsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialUpdateWithoutPriceSubGroupsInput = {
  Category?: InputMaybe<CategoryUpdateOneWithoutMaterialsNestedInput>;
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowUpdateManyWithoutAssociatedMaterialNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  previewImageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaterialUpsertWithWhereUniqueWithoutCategoryInput = {
  create: MaterialCreateWithoutCategoryInput;
  update: MaterialUpdateWithoutCategoryInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialUpsertWithWhereUniqueWithoutPriceSubGroupsInput = {
  create: MaterialCreateWithoutPriceSubGroupsInput;
  update: MaterialUpdateWithoutPriceSubGroupsInput;
  where: MaterialWhereUniqueInput;
};

export type MaterialUpsertWithoutMaterialImportSheetRowInput = {
  create: MaterialCreateWithoutMaterialImportSheetRowInput;
  update: MaterialUpdateWithoutMaterialImportSheetRowInput;
  where?: InputMaybe<MaterialWhereInput>;
};

export type MaterialWhereInput = {
  AND?: InputMaybe<Array<MaterialWhereInput>>;
  Category?: InputMaybe<CategoryNullableRelationFilter>;
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowListRelationFilter>;
  NOT?: InputMaybe<Array<MaterialWhereInput>>;
  OR?: InputMaybe<Array<MaterialWhereInput>>;
  categoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  previewImageId?: InputMaybe<StringFilter>;
  previewImageUrl?: InputMaybe<StringFilter>;
  priceSubGroupIds?: InputMaybe<StringNullableListFilter>;
  priceSubGroups?: InputMaybe<PriceSubGroupListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MaterialWhereUniqueInput = {
  AND?: InputMaybe<Array<MaterialWhereInput>>;
  Category?: InputMaybe<CategoryNullableRelationFilter>;
  MaterialImportSheetRow?: InputMaybe<MaterialImportSheetRowListRelationFilter>;
  NOT?: InputMaybe<Array<MaterialWhereInput>>;
  OR?: InputMaybe<Array<MaterialWhereInput>>;
  categoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId?: InputMaybe<Scalars['String']['input']>;
  previewImageId?: InputMaybe<StringFilter>;
  previewImageUrl?: InputMaybe<StringFilter>;
  priceSubGroupIds?: InputMaybe<StringNullableListFilter>;
  priceSubGroups?: InputMaybe<PriceSubGroupListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createManyProductOptionsImportSheet: AffectedRowsOutput;
  createOneCategory: Category;
  createOneMaterial: Material;
  createOnePriceGroup: PriceGroup;
  createOnePriceSubGroup: PriceSubGroup;
  createOneProductOptionsImportSheet: ProductOptionsImportSheet;
  createOneVariantOption: VariantOption;
  deleteManyCategory: AffectedRowsOutput;
  deleteManyMaterialImportSheetRow: AffectedRowsOutput;
  deleteManyProductOptionsImportSheet: AffectedRowsOutput;
  deleteOneCategory?: Maybe<Category>;
  deleteOneMaterial?: Maybe<Material>;
  deleteOneMaterialImportSheetRow?: Maybe<MaterialImportSheetRow>;
  deleteOnePriceSubGroup?: Maybe<PriceSubGroup>;
  deleteOneProductOptionsImportSheet?: Maybe<ProductOptionsImportSheet>;
  updateManyMaterialImportSheetRow: AffectedRowsOutput;
  updateManyProductOptionsImportSheet: AffectedRowsOutput;
  updateOneCategory?: Maybe<Category>;
  updateOneMaterial: Material;
  updateOneMaterialImportSheetRow?: Maybe<MaterialImportSheetRow>;
  updateOnePriceGroup: PriceGroup;
  updateOnePriceSubGroup: PriceSubGroup;
  updateOneProductOptionsImportSheet?: Maybe<ProductOptionsImportSheet>;
  updateOneVariantOption: VariantOption;
  updateProductVariantPrice: Array<ProductVariant>;
  upsertOneProductOptionsImportSheet: ProductOptionsImportSheet;
};


export type MutationCreateManyProductOptionsImportSheetArgs = {
  data: Array<ProductOptionsImportSheetCreateManyInput>;
};


export type MutationCreateOneCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateOneMaterialArgs = {
  data: MaterialCreateWithShopifyInput;
};


export type MutationCreateOnePriceGroupArgs = {
  data: CreateOnePriceGroupWithShopifyDefinitionInput;
};


export type MutationCreateOnePriceSubGroupArgs = {
  data: PriceSubGroupCreateWithShopifyInput;
};


export type MutationCreateOneProductOptionsImportSheetArgs = {
  data: ProductOptionsImportSheetCreateInput;
};


export type MutationCreateOneVariantOptionArgs = {
  data: CreateVariantOptionWithShopifyDefinitionInput;
};


export type MutationDeleteManyCategoryArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type MutationDeleteManyMaterialImportSheetRowArgs = {
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type MutationDeleteManyProductOptionsImportSheetArgs = {
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type MutationDeleteOneCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteOneMaterialArgs = {
  where: MaterialWhereUniqueInput;
};


export type MutationDeleteOneMaterialImportSheetRowArgs = {
  where: MaterialImportSheetRowWhereUniqueInput;
};


export type MutationDeleteOnePriceSubGroupArgs = {
  where: PriceSubGroupWhereUniqueInput;
};


export type MutationDeleteOneProductOptionsImportSheetArgs = {
  where: ProductOptionsImportSheetWhereUniqueInput;
};


export type MutationUpdateManyMaterialImportSheetRowArgs = {
  data: MaterialImportSheetRowUpdateManyMutationInput;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type MutationUpdateManyProductOptionsImportSheetArgs = {
  data: ProductOptionsImportSheetUpdateManyMutationInput;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type MutationUpdateOneCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateOneMaterialArgs = {
  data: MaterialUpdateWithShopifyDefinitionInput;
  where: MaterialWhereUniqueInput;
};


export type MutationUpdateOneMaterialImportSheetRowArgs = {
  data: MaterialImportSheetRowUpdateInput;
  where: MaterialImportSheetRowWhereUniqueInput;
};


export type MutationUpdateOnePriceGroupArgs = {
  data: UpdateOnePriceGroupInput;
  where: PriceGroupWhereUniqueInput;
};


export type MutationUpdateOnePriceSubGroupArgs = {
  data: PriceSubGroupUpdateWithShopifyInput;
  where: PriceSubGroupWhereUniqueIdInput;
};


export type MutationUpdateOneProductOptionsImportSheetArgs = {
  data: ProductOptionsImportSheetUpdateInput;
  where: ProductOptionsImportSheetWhereUniqueInput;
};


export type MutationUpdateOneVariantOptionArgs = {
  data: UpdateOneVariantOptionInput;
  where: VariantOptionWhereUniqueIdInput;
};


export type MutationUpdateProductVariantPriceArgs = {
  data: Array<UpdateProductVariantPriceInput>;
};


export type MutationUpsertOneProductOptionsImportSheetArgs = {
  create: ProductOptionsImportSheetCreateInput;
  update: ProductOptionsImportSheetUpdateInput;
  where: ProductOptionsImportSheetWhereUniqueInput;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>;
};

export type NestedEnumBulkImportStatusFilter = {
  equals?: InputMaybe<BulkImportStatus>;
  in?: InputMaybe<Array<BulkImportStatus>>;
  not?: InputMaybe<NestedEnumBulkImportStatusFilter>;
  notIn?: InputMaybe<Array<BulkImportStatus>>;
};

export type NestedEnumProductOptionsImportStatusFilter = {
  equals?: InputMaybe<ProductOptionsImportStatus>;
  in?: InputMaybe<Array<ProductOptionsImportStatus>>;
  not?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  notIn?: InputMaybe<Array<ProductOptionsImportStatus>>;
};

export type NestedEnumProductOptionsImportStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  _min?: InputMaybe<NestedEnumProductOptionsImportStatusFilter>;
  equals?: InputMaybe<ProductOptionsImportStatus>;
  in?: InputMaybe<Array<ProductOptionsImportStatus>>;
  not?: InputMaybe<NestedEnumProductOptionsImportStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ProductOptionsImportStatus>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceGroup = {
  __typename?: 'PriceGroup';
  _count?: Maybe<PriceGroupCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  metaObjectId: Scalars['String']['output'];
  priceSubGroups: Array<PriceSubGroup>;
  updatedAt: Scalars['DateTimeISO']['output'];
  variantOption?: Maybe<VariantOption>;
  variantOptionId?: Maybe<Scalars['String']['output']>;
  variantOptionValue: Scalars['String']['output'];
};


export type PriceGroupPriceSubGroupsArgs = {
  cursor?: InputMaybe<PriceSubGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceSubGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceSubGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceSubGroupWhereInput>;
};


export type PriceGroupVariantOptionArgs = {
  where?: InputMaybe<VariantOptionWhereInput>;
};

export type PriceGroupCount = {
  __typename?: 'PriceGroupCount';
  priceSubGroups: Scalars['Int']['output'];
};


export type PriceGroupCountPriceSubGroupsArgs = {
  where?: InputMaybe<PriceSubGroupWhereInput>;
};

export type PriceGroupCountAggregate = {
  __typename?: 'PriceGroupCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metaObjectId: Scalars['Int']['output'];
  shopifySessionId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  variantOptionId: Scalars['Int']['output'];
  variantOptionValue: Scalars['Int']['output'];
};

export type PriceGroupCreateNestedOneWithoutPriceSubGroupsInput = {
  connect?: InputMaybe<PriceGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceGroupCreateOrConnectWithoutPriceSubGroupsInput>;
  create?: InputMaybe<PriceGroupCreateWithoutPriceSubGroupsInput>;
};

export type PriceGroupCreateOrConnectWithoutPriceSubGroupsInput = {
  create: PriceGroupCreateWithoutPriceSubGroupsInput;
  where: PriceGroupWhereUniqueInput;
};

export type PriceGroupCreateWithoutPriceSubGroupsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  variantOption?: InputMaybe<VariantOptionCreateNestedOneWithoutPriceGroupsInput>;
  variantOptionValue: Scalars['String']['input'];
};

export type PriceGroupListRelationFilter = {
  every?: InputMaybe<PriceGroupWhereInput>;
  none?: InputMaybe<PriceGroupWhereInput>;
  some?: InputMaybe<PriceGroupWhereInput>;
};

export type PriceGroupMaxAggregate = {
  __typename?: 'PriceGroupMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metaObjectId?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  variantOptionId?: Maybe<Scalars['String']['output']>;
  variantOptionValue?: Maybe<Scalars['String']['output']>;
};

export type PriceGroupMinAggregate = {
  __typename?: 'PriceGroupMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metaObjectId?: Maybe<Scalars['String']['output']>;
  shopifySessionId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  variantOptionId?: Maybe<Scalars['String']['output']>;
  variantOptionValue?: Maybe<Scalars['String']['output']>;
};

export type PriceGroupNullableRelationFilter = {
  is?: InputMaybe<PriceGroupWhereInput>;
  isNot?: InputMaybe<PriceGroupWhereInput>;
};

export type PriceGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PriceGroupOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaObjectId?: InputMaybe<SortOrder>;
  priceSubGroups?: InputMaybe<PriceSubGroupOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  variantOption?: InputMaybe<VariantOptionOrderByWithRelationInput>;
  variantOptionId?: InputMaybe<SortOrder>;
  variantOptionValue?: InputMaybe<SortOrder>;
};

export enum PriceGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  MetaObjectId = 'metaObjectId',
  ShopifySessionId = 'shopifySessionId',
  UpdatedAt = 'updatedAt',
  VariantOptionId = 'variantOptionId',
  VariantOptionValue = 'variantOptionValue'
}

export type PriceGroupUpdateOneWithoutPriceSubGroupsNestedInput = {
  connect?: InputMaybe<PriceGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceGroupCreateOrConnectWithoutPriceSubGroupsInput>;
  create?: InputMaybe<PriceGroupCreateWithoutPriceSubGroupsInput>;
  delete?: InputMaybe<PriceGroupWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<PriceGroupUpdateToOneWithWhereWithoutPriceSubGroupsInput>;
  upsert?: InputMaybe<PriceGroupUpsertWithoutPriceSubGroupsInput>;
};

export type PriceGroupUpdateToOneWithWhereWithoutPriceSubGroupsInput = {
  data: PriceGroupUpdateWithoutPriceSubGroupsInput;
  where?: InputMaybe<PriceGroupWhereInput>;
};

export type PriceGroupUpdateWithoutPriceSubGroupsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  variantOption?: InputMaybe<VariantOptionUpdateOneWithoutPriceGroupsNestedInput>;
  variantOptionValue?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PriceGroupUpsertWithoutPriceSubGroupsInput = {
  create: PriceGroupCreateWithoutPriceSubGroupsInput;
  update: PriceGroupUpdateWithoutPriceSubGroupsInput;
  where?: InputMaybe<PriceGroupWhereInput>;
};

export type PriceGroupWhereInput = {
  AND?: InputMaybe<Array<PriceGroupWhereInput>>;
  NOT?: InputMaybe<Array<PriceGroupWhereInput>>;
  OR?: InputMaybe<Array<PriceGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  priceSubGroups?: InputMaybe<PriceSubGroupListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOption?: InputMaybe<VariantOptionNullableRelationFilter>;
  variantOptionId?: InputMaybe<StringNullableFilter>;
  variantOptionValue?: InputMaybe<StringFilter>;
};

export type PriceGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<PriceGroupWhereInput>>;
  NOT?: InputMaybe<Array<PriceGroupWhereInput>>;
  OR?: InputMaybe<Array<PriceGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId?: InputMaybe<Scalars['String']['input']>;
  priceSubGroups?: InputMaybe<PriceSubGroupListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOption?: InputMaybe<VariantOptionNullableRelationFilter>;
  variantOptionId?: InputMaybe<StringNullableFilter>;
  variantOptionValue?: InputMaybe<StringFilter>;
};

export type PriceSubGroup = {
  __typename?: 'PriceSubGroup';
  _count?: Maybe<PriceSubGroupCount>;
  category: Category;
  categoryId: Scalars['String']['output'];
  composition: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materialIds: Array<Scalars['String']['output']>;
  materials: Array<Material>;
  metaObjectId: Scalars['String']['output'];
  priceGroup?: Maybe<PriceGroup>;
  priceGroupId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  url: Scalars['String']['output'];
};


export type PriceSubGroupMaterialsArgs = {
  cursor?: InputMaybe<MaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialWhereInput>;
};


export type PriceSubGroupPriceGroupArgs = {
  where?: InputMaybe<PriceGroupWhereInput>;
};

export type PriceSubGroupCount = {
  __typename?: 'PriceSubGroupCount';
  materials: Scalars['Int']['output'];
};


export type PriceSubGroupCountMaterialsArgs = {
  where?: InputMaybe<MaterialWhereInput>;
};

export type PriceSubGroupCreateManyCategoryInput = {
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<PriceSubGroupCreatematerialIdsInput>;
  metaObjectId: Scalars['String']['input'];
  priceGroupId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type PriceSubGroupCreateManyCategoryInputEnvelope = {
  data: Array<PriceSubGroupCreateManyCategoryInput>;
};

export type PriceSubGroupCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceSubGroupCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<PriceSubGroupCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<PriceSubGroupCreateManyCategoryInputEnvelope>;
};

export type PriceSubGroupCreateNestedManyWithoutMaterialsInput = {
  connect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceSubGroupCreateOrConnectWithoutMaterialsInput>>;
  create?: InputMaybe<Array<PriceSubGroupCreateWithoutMaterialsInput>>;
};

export type PriceSubGroupCreateOrConnectWithoutCategoryInput = {
  create: PriceSubGroupCreateWithoutCategoryInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupCreateOrConnectWithoutMaterialsInput = {
  create: PriceSubGroupCreateWithoutMaterialsInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupCreateWithShopifyInput = {
  categoryId: Scalars['String']['input'];
  composition: Scalars['String']['input'];
  description: Scalars['String']['input'];
  designer: Scalars['String']['input'];
  materialIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PriceSubGroupCreateWithoutCategoryInput = {
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  materials?: InputMaybe<MaterialCreateNestedManyWithoutPriceSubGroupsInput>;
  metaObjectId: Scalars['String']['input'];
  priceGroup?: InputMaybe<PriceGroupCreateNestedOneWithoutPriceSubGroupsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type PriceSubGroupCreateWithoutMaterialsInput = {
  category: CategoryCreateNestedOneWithoutPriceSubGroupInput;
  composition: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  priceGroup?: InputMaybe<PriceGroupCreateNestedOneWithoutPriceSubGroupsInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  url: Scalars['String']['input'];
};

export type PriceSubGroupCreatematerialIdsInput = {
  set: Array<Scalars['String']['input']>;
};

export type PriceSubGroupListRelationFilter = {
  every?: InputMaybe<PriceSubGroupWhereInput>;
  none?: InputMaybe<PriceSubGroupWhereInput>;
  some?: InputMaybe<PriceSubGroupWhereInput>;
};

export type PriceSubGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PriceSubGroupOrderByWithRelationInput = {
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  composition?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  designer?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  materialIds?: InputMaybe<SortOrder>;
  materials?: InputMaybe<MaterialOrderByRelationAggregateInput>;
  metaObjectId?: InputMaybe<SortOrder>;
  priceGroup?: InputMaybe<PriceGroupOrderByWithRelationInput>;
  priceGroupId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export enum PriceSubGroupScalarFieldEnum {
  CategoryId = 'categoryId',
  Composition = 'composition',
  CreatedAt = 'createdAt',
  Description = 'description',
  Designer = 'designer',
  Id = 'id',
  MaterialIds = 'materialIds',
  MetaObjectId = 'metaObjectId',
  PriceGroupId = 'priceGroupId',
  ShopifySessionId = 'shopifySessionId',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type PriceSubGroupScalarWhereInput = {
  AND?: InputMaybe<Array<PriceSubGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<PriceSubGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<PriceSubGroupScalarWhereInput>>;
  categoryId?: InputMaybe<StringFilter>;
  composition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designer?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  materialIds?: InputMaybe<StringNullableListFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  priceGroupId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PriceSubGroupUpdateManyMutationInput = {
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PriceSubGroupUpdateManyWithWhereWithoutCategoryInput = {
  data: PriceSubGroupUpdateManyMutationInput;
  where: PriceSubGroupScalarWhereInput;
};

export type PriceSubGroupUpdateManyWithWhereWithoutMaterialsInput = {
  data: PriceSubGroupUpdateManyMutationInput;
  where: PriceSubGroupScalarWhereInput;
};

export type PriceSubGroupUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceSubGroupCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<PriceSubGroupCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<PriceSubGroupCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceSubGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceSubGroupUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<PriceSubGroupUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<PriceSubGroupUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type PriceSubGroupUpdateManyWithoutMaterialsNestedInput = {
  connect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceSubGroupCreateOrConnectWithoutMaterialsInput>>;
  create?: InputMaybe<Array<PriceSubGroupCreateWithoutMaterialsInput>>;
  delete?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceSubGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceSubGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceSubGroupUpdateWithWhereUniqueWithoutMaterialsInput>>;
  updateMany?: InputMaybe<Array<PriceSubGroupUpdateManyWithWhereWithoutMaterialsInput>>;
  upsert?: InputMaybe<Array<PriceSubGroupUpsertWithWhereUniqueWithoutMaterialsInput>>;
};

export type PriceSubGroupUpdateWithShopifyInput = {
  composition?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  designer?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PriceSubGroupUpdateWithWhereUniqueWithoutCategoryInput = {
  data: PriceSubGroupUpdateWithoutCategoryInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupUpdateWithWhereUniqueWithoutMaterialsInput = {
  data: PriceSubGroupUpdateWithoutMaterialsInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupUpdateWithoutCategoryInput = {
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  materials?: InputMaybe<MaterialUpdateManyWithoutPriceSubGroupsNestedInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceGroup?: InputMaybe<PriceGroupUpdateOneWithoutPriceSubGroupsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PriceSubGroupUpdateWithoutMaterialsInput = {
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutPriceSubGroupNestedInput>;
  composition?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  designer?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  priceGroup?: InputMaybe<PriceGroupUpdateOneWithoutPriceSubGroupsNestedInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PriceSubGroupUpsertWithWhereUniqueWithoutCategoryInput = {
  create: PriceSubGroupCreateWithoutCategoryInput;
  update: PriceSubGroupUpdateWithoutCategoryInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupUpsertWithWhereUniqueWithoutMaterialsInput = {
  create: PriceSubGroupCreateWithoutMaterialsInput;
  update: PriceSubGroupUpdateWithoutMaterialsInput;
  where: PriceSubGroupWhereUniqueInput;
};

export type PriceSubGroupWhereInput = {
  AND?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  NOT?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  OR?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  composition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designer?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  materialIds?: InputMaybe<StringNullableListFilter>;
  materials?: InputMaybe<MaterialListRelationFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  priceGroup?: InputMaybe<PriceGroupNullableRelationFilter>;
  priceGroupId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PriceSubGroupWhereUniqueIdInput = {
  id: Scalars['String']['input'];
};

export type PriceSubGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  NOT?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  OR?: InputMaybe<Array<PriceSubGroupWhereInput>>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  composition?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  designer?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  materialIds?: InputMaybe<StringNullableListFilter>;
  materials?: InputMaybe<MaterialListRelationFilter>;
  metaObjectId?: InputMaybe<Scalars['String']['input']>;
  priceGroup?: InputMaybe<PriceGroupNullableRelationFilter>;
  priceGroupId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type Product = {
  __typename?: 'Product';
  _count?: Maybe<ProductCount>;
  adminGraphQlId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  legacyGraphQlId: Scalars['BigInt']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  variantOptions: Array<VariantOption>;
};


export type ProductVariantOptionsArgs = {
  cursor?: InputMaybe<VariantOptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<VariantOptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VariantOptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VariantOptionWhereInput>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  variantOptions: Scalars['Int']['output'];
};


export type ProductCountVariantOptionsArgs = {
  where?: InputMaybe<VariantOptionWhereInput>;
};

export type ProductCreateNestedOneWithoutVariantOptionsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutVariantOptionsInput>;
  create?: InputMaybe<ProductCreateWithoutVariantOptionsInput>;
};

export type ProductCreateOrConnectWithoutVariantOptionsInput = {
  create: ProductCreateWithoutVariantOptionsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutVariantOptionsInput = {
  adminGraphQlId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacyGraphQlId: Scalars['BigInt']['input'];
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProductNullableRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductOptionsImportSheet = {
  __typename?: 'ProductOptionsImportSheet';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  resultFile?: Maybe<Scalars['String']['output']>;
  status: ProductOptionsImportStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProductOptionsImportSheetCountAggregate = {
  __typename?: 'ProductOptionsImportSheetCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  resultFile: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProductOptionsImportSheetCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOptionsImportSheetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFile?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductOptionsImportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProductOptionsImportSheetCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFile?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProductOptionsImportStatus>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ProductOptionsImportSheetGroupBy = {
  __typename?: 'ProductOptionsImportSheetGroupBy';
  _count?: Maybe<ProductOptionsImportSheetCountAggregate>;
  _max?: Maybe<ProductOptionsImportSheetMaxAggregate>;
  _min?: Maybe<ProductOptionsImportSheetMinAggregate>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  resultFile?: Maybe<Scalars['String']['output']>;
  status: ProductOptionsImportStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProductOptionsImportSheetMaxAggregate = {
  __typename?: 'ProductOptionsImportSheetMaxAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  resultFile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductOptionsImportStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductOptionsImportSheetMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOptionsImportSheetMinAggregate = {
  __typename?: 'ProductOptionsImportSheetMinAggregate';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  resultFile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProductOptionsImportStatus>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ProductOptionsImportSheetMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOptionsImportSheetOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductOptionsImportSheetCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductOptionsImportSheetMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductOptionsImportSheetMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductOptionsImportSheetOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  resultFile?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductOptionsImportSheetScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  ResultFile = 'resultFile',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type ProductOptionsImportSheetScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductOptionsImportSheetScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductOptionsImportSheetScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductOptionsImportSheetScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  resultFile?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumProductOptionsImportStatusWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ProductOptionsImportSheetUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resultFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductOptionsImportStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOptionsImportSheetUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  resultFile?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumProductOptionsImportStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOptionsImportSheetWhereInput = {
  AND?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  NOT?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  resultFile?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumProductOptionsImportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductOptionsImportSheetWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  NOT?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionsImportSheetWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  resultFile?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumProductOptionsImportStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum ProductOptionsImportStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  ValidationError = 'VALIDATION_ERROR'
}

export type ProductOrderByWithRelationInput = {
  adminGraphQlId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legacyGraphQlId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  variantOptions?: InputMaybe<VariantOptionOrderByRelationAggregateInput>;
};

export enum ProductScalarFieldEnum {
  AdminGraphQlId = 'adminGraphQlId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LegacyGraphQlId = 'legacyGraphQlId',
  ShopifySessionId = 'shopifySessionId',
  UpdatedAt = 'updatedAt'
}

export type ProductUpdateOneWithoutVariantOptionsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutVariantOptionsInput>;
  create?: InputMaybe<ProductCreateWithoutVariantOptionsInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutVariantOptionsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutVariantOptionsInput>;
};

export type ProductUpdateToOneWithWhereWithoutVariantOptionsInput = {
  data: ProductUpdateWithoutVariantOptionsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithoutVariantOptionsInput = {
  adminGraphQlId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  legacyGraphQlId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpsertWithoutVariantOptionsInput = {
  create: ProductCreateWithoutVariantOptionsInput;
  update: ProductUpdateWithoutVariantOptionsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  compareAtPrice?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  price: Scalars['String']['output'];
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  adminGraphQlId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  legacyGraphQlId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOptions?: InputMaybe<VariantOptionListRelationFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  adminGraphQlId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacyGraphQlId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOptions?: InputMaybe<VariantOptionListRelationFilter>;
};

export type Query = {
  __typename?: 'Query';
  aggregateCategory: AggregateCategory;
  aggregateMaterial: AggregateMaterial;
  aggregateMaterialImportSheetRow: AggregateMaterialImportSheetRow;
  aggregatePriceGroup: AggregatePriceGroup;
  aggregateProductOptionsImportSheet: AggregateProductOptionsImportSheet;
  categories: Array<Category>;
  category?: Maybe<Category>;
  findFirstMaterialImportSheetRow?: Maybe<MaterialImportSheetRow>;
  findFirstMaterialImportSheetRowOrThrow?: Maybe<MaterialImportSheetRow>;
  findFirstProductOptionsImportSheet?: Maybe<ProductOptionsImportSheet>;
  findFirstProductOptionsImportSheetOrThrow?: Maybe<ProductOptionsImportSheet>;
  getMaterialImportSheetRow?: Maybe<MaterialImportSheetRow>;
  getProductOptionsImportSheet?: Maybe<ProductOptionsImportSheet>;
  groupByProductOptionsImportSheet: Array<ProductOptionsImportSheetGroupBy>;
  materialImportSheetRow?: Maybe<MaterialImportSheetRow>;
  materialImportSheetRows: Array<MaterialImportSheetRow>;
  materials: Array<Material>;
  productOptionsImportSheet?: Maybe<ProductOptionsImportSheet>;
  productOptionsImportSheets: Array<ProductOptionsImportSheet>;
  products: Array<Product>;
  shopifyProducts: ShopifyProduct;
};


export type QueryAggregateCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryAggregateMaterialArgs = {
  cursor?: InputMaybe<MaterialWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MaterialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialWhereInput>;
};


export type QueryAggregateMaterialImportSheetRowArgs = {
  cursor?: InputMaybe<MaterialImportSheetRowWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type QueryAggregatePriceGroupArgs = {
  cursor?: InputMaybe<PriceGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PriceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceGroupWhereInput>;
};


export type QueryAggregateProductOptionsImportSheetArgs = {
  cursor?: InputMaybe<ProductOptionsImportSheetWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type QueryCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryFindFirstMaterialImportSheetRowArgs = {
  cursor?: InputMaybe<MaterialImportSheetRowWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialImportSheetRowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type QueryFindFirstMaterialImportSheetRowOrThrowArgs = {
  cursor?: InputMaybe<MaterialImportSheetRowWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialImportSheetRowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type QueryFindFirstProductOptionsImportSheetArgs = {
  cursor?: InputMaybe<ProductOptionsImportSheetWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOptionsImportSheetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type QueryFindFirstProductOptionsImportSheetOrThrowArgs = {
  cursor?: InputMaybe<ProductOptionsImportSheetWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOptionsImportSheetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type QueryGetMaterialImportSheetRowArgs = {
  where: MaterialImportSheetRowWhereUniqueInput;
};


export type QueryGetProductOptionsImportSheetArgs = {
  where: ProductOptionsImportSheetWhereUniqueInput;
};


export type QueryGroupByProductOptionsImportSheetArgs = {
  by: Array<ProductOptionsImportSheetScalarFieldEnum>;
  having?: InputMaybe<ProductOptionsImportSheetScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type QueryMaterialImportSheetRowArgs = {
  where: MaterialImportSheetRowWhereUniqueInput;
};


export type QueryMaterialImportSheetRowsArgs = {
  cursor?: InputMaybe<MaterialImportSheetRowWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialImportSheetRowScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
};


export type QueryMaterialsArgs = {
  cursor?: InputMaybe<MaterialWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaterialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaterialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialWhereInput>;
};


export type QueryProductOptionsImportSheetArgs = {
  where: ProductOptionsImportSheetWhereUniqueInput;
};


export type QueryProductOptionsImportSheetsArgs = {
  cursor?: InputMaybe<ProductOptionsImportSheetWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOptionsImportSheetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
};


export type QueryProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryShopifyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type ShopifyPageInfo = {
  __typename?: 'ShopifyPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ShopifyProduct = {
  __typename?: 'ShopifyProduct';
  pageInfo: ShopifyPageInfo;
  queryResult: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isSet?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  jobCompletionNotification?: Maybe<ImportJobCompletion>;
  jobProgressNotification?: Maybe<MaterialImportSheetRow>;
};

export type UpdateOnePriceGroupInput = {
  priceSubGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  variantOptionValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneVariantOptionInput = {
  priceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProductVariantPriceInput = {
  compareAtPrice?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['String']['input'];
  variantGqlId: Scalars['String']['input'];
};

export type VariantOption = {
  __typename?: 'VariantOption';
  _count?: Maybe<VariantOptionCount>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  metaObjectId: Scalars['String']['output'];
  priceGroups: Array<PriceGroup>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  variantOptionName: Scalars['String']['output'];
};


export type VariantOptionPriceGroupsArgs = {
  cursor?: InputMaybe<PriceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PriceGroupWhereInput>;
};


export type VariantOptionProductArgs = {
  where?: InputMaybe<ProductWhereInput>;
};

export type VariantOptionCount = {
  __typename?: 'VariantOptionCount';
  priceGroups: Scalars['Int']['output'];
};


export type VariantOptionCountPriceGroupsArgs = {
  where?: InputMaybe<PriceGroupWhereInput>;
};

export type VariantOptionCreateNestedOneWithoutPriceGroupsInput = {
  connect?: InputMaybe<VariantOptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VariantOptionCreateOrConnectWithoutPriceGroupsInput>;
  create?: InputMaybe<VariantOptionCreateWithoutPriceGroupsInput>;
};

export type VariantOptionCreateOrConnectWithoutPriceGroupsInput = {
  create: VariantOptionCreateWithoutPriceGroupsInput;
  where: VariantOptionWhereUniqueInput;
};

export type VariantOptionCreateWithoutPriceGroupsInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId: Scalars['String']['input'];
  product?: InputMaybe<ProductCreateNestedOneWithoutVariantOptionsInput>;
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  variantOptionName: Scalars['String']['input'];
};

export type VariantOptionListRelationFilter = {
  every?: InputMaybe<VariantOptionWhereInput>;
  none?: InputMaybe<VariantOptionWhereInput>;
  some?: InputMaybe<VariantOptionWhereInput>;
};

export type VariantOptionNullableRelationFilter = {
  is?: InputMaybe<VariantOptionWhereInput>;
  isNot?: InputMaybe<VariantOptionWhereInput>;
};

export type VariantOptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VariantOptionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaObjectId?: InputMaybe<SortOrder>;
  priceGroups?: InputMaybe<PriceGroupOrderByRelationAggregateInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  variantOptionName?: InputMaybe<SortOrder>;
};

export enum VariantOptionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  MetaObjectId = 'metaObjectId',
  ProductId = 'productId',
  ShopifySessionId = 'shopifySessionId',
  UpdatedAt = 'updatedAt',
  VariantOptionName = 'variantOptionName'
}

export type VariantOptionUpdateOneWithoutPriceGroupsNestedInput = {
  connect?: InputMaybe<VariantOptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VariantOptionCreateOrConnectWithoutPriceGroupsInput>;
  create?: InputMaybe<VariantOptionCreateWithoutPriceGroupsInput>;
  delete?: InputMaybe<VariantOptionWhereInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<VariantOptionUpdateToOneWithWhereWithoutPriceGroupsInput>;
  upsert?: InputMaybe<VariantOptionUpsertWithoutPriceGroupsInput>;
};

export type VariantOptionUpdateToOneWithWhereWithoutPriceGroupsInput = {
  data: VariantOptionUpdateWithoutPriceGroupsInput;
  where?: InputMaybe<VariantOptionWhereInput>;
};

export type VariantOptionUpdateWithoutPriceGroupsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metaObjectId?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutVariantOptionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  variantOptionName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VariantOptionUpsertWithoutPriceGroupsInput = {
  create: VariantOptionCreateWithoutPriceGroupsInput;
  update: VariantOptionUpdateWithoutPriceGroupsInput;
  where?: InputMaybe<VariantOptionWhereInput>;
};

export type VariantOptionWhereInput = {
  AND?: InputMaybe<Array<VariantOptionWhereInput>>;
  NOT?: InputMaybe<Array<VariantOptionWhereInput>>;
  OR?: InputMaybe<Array<VariantOptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metaObjectId?: InputMaybe<StringFilter>;
  priceGroups?: InputMaybe<PriceGroupListRelationFilter>;
  product?: InputMaybe<ProductNullableRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOptionName?: InputMaybe<StringFilter>;
};

export type VariantOptionWhereUniqueIdInput = {
  id: Scalars['String']['input'];
};

export type VariantOptionWhereUniqueInput = {
  AND?: InputMaybe<Array<VariantOptionWhereInput>>;
  NOT?: InputMaybe<Array<VariantOptionWhereInput>>;
  OR?: InputMaybe<Array<VariantOptionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metaObjectId?: InputMaybe<Scalars['String']['input']>;
  priceGroups?: InputMaybe<PriceGroupListRelationFilter>;
  product?: InputMaybe<ProductNullableRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variantOptionName?: InputMaybe<StringFilter>;
};

export type ShopifyProductsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopifyProductsQuery = { __typename?: 'Query', shopifyProducts: { __typename?: 'ShopifyProduct', queryResult: string, pageInfo: { __typename?: 'ShopifyPageInfo', endCursor?: string | null, hasNextPage: boolean, startCursor?: string | null, hasPreviousPage: boolean } } };

export type MaterialsWithCategoriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaterialWhereInput>;
  orderBy?: InputMaybe<Array<MaterialOrderByWithRelationInput> | MaterialOrderByWithRelationInput>;
}>;


export type MaterialsWithCategoriesQuery = { __typename?: 'Query', materials: Array<{ __typename?: 'Material', title: string, previewImageUrl: string, previewImageId: string, metaObjectId: string, id: string, Category?: { __typename?: 'Category', title: string, id: string } | null }> };

export type CategoriesQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', title: string, id: string }> };

export type CategoriesWithMaterialsQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesWithMaterialsQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', title: string, url: string, id: string, designer: string, description?: string | null, composition: string, materials: Array<{ __typename?: 'Material', id: string, title: string, previewImageUrl: string }> }> };

export type AllCategoriesByPageQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput> | CategoryOrderByWithRelationInput>;
}>;


export type AllCategoriesByPageQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', composition: string, description?: string | null, designer: string, id: string, title: string, url: string, materials: Array<{ __typename?: 'Material', id: string, previewImageUrl: string, title: string }> }> };

export type AggregateMaterialQueryVariables = Exact<{
  where?: InputMaybe<MaterialWhereInput>;
}>;


export type AggregateMaterialQuery = { __typename?: 'Query', aggregateMaterial: { __typename?: 'AggregateMaterial', _count?: { __typename?: 'MaterialCountAggregate', _all: number } | null } };

export type CreateOneMaterialMutationVariables = Exact<{
  data: MaterialCreateWithShopifyInput;
}>;


export type CreateOneMaterialMutation = { __typename?: 'Mutation', createOneMaterial: { __typename?: 'Material', id: string, previewImageUrl: string, categoryId?: string | null, title: string } };

export type UpdateMaterialWithShopifyDefinitionMutationVariables = Exact<{
  data: MaterialUpdateWithShopifyDefinitionInput;
  where: MaterialWhereUniqueInput;
}>;


export type UpdateMaterialWithShopifyDefinitionMutation = { __typename?: 'Mutation', updateOneMaterial: { __typename?: 'Material', id: string, previewImageUrl: string, title: string, categoryId?: string | null } };

export type DeleteOneMaterialMutationVariables = Exact<{
  where: MaterialWhereUniqueInput;
}>;


export type DeleteOneMaterialMutation = { __typename?: 'Mutation', deleteOneMaterial?: { __typename?: 'Material', id: string } | null };

export type CreateOneCategoryMutationVariables = Exact<{
  data: CategoryCreateInput;
}>;


export type CreateOneCategoryMutation = { __typename?: 'Mutation', createOneCategory: { __typename?: 'Category', id: string, title: string, url: string } };

export type UpdateOneCategoryMutationVariables = Exact<{
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
}>;


export type UpdateOneCategoryMutation = { __typename?: 'Mutation', updateOneCategory?: { __typename?: 'Category', title: string, url: string, composition: string, designer: string, materials: Array<{ __typename?: 'Material', id: string, previewImageUrl: string, title: string }> } | null };

export type CategoryQueryVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type CategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', _count?: { __typename?: 'CategoryCount', PriceSubGroup: number, materials: number } | null } | null };

export type DeleteOneCategoryMutationVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type DeleteOneCategoryMutation = { __typename?: 'Mutation', deleteOneCategory?: { __typename?: 'Category', id: string, title: string } | null };

export type DeleteOnePriceSubGroupMutationVariables = Exact<{
  where: PriceSubGroupWhereUniqueInput;
}>;


export type DeleteOnePriceSubGroupMutation = { __typename?: 'Mutation', deleteOnePriceSubGroup?: { __typename?: 'PriceSubGroup', id: string, title: string } | null };

export type AggregateCategoryQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
}>;


export type AggregateCategoryQuery = { __typename?: 'Query', aggregateCategory: { __typename?: 'AggregateCategory', _count?: { __typename?: 'CategoryCountAggregate', _all: number } | null } };

export type _CountQueryVariables = Exact<{
  where?: InputMaybe<MaterialImportSheetRowWhereInput>;
}>;


export type _CountQuery = { __typename?: 'Query', aggregateMaterialImportSheetRow: { __typename?: 'AggregateMaterialImportSheetRow', _count?: { __typename?: 'MaterialImportSheetRowCountAggregate', _all: number } | null } };

export type AggregateProductOptionsImportSheetSuccessfullyQueryVariables = Exact<{
  where?: InputMaybe<ProductOptionsImportSheetWhereInput>;
}>;


export type AggregateProductOptionsImportSheetSuccessfullyQuery = { __typename?: 'Query', aggregateProductOptionsImportSheet: { __typename?: 'AggregateProductOptionsImportSheet', _count?: { __typename?: 'ProductOptionsImportSheetCountAggregate', _all: number } | null } };

export type AggregateMaterialImportSheetRowQueryVariables = Exact<{ [key: string]: never; }>;


export type AggregateMaterialImportSheetRowQuery = { __typename?: 'Query', aggregateMaterialImportSheetRow: { __typename?: 'AggregateMaterialImportSheetRow', _count?: { __typename?: 'MaterialImportSheetRowCountAggregate', _all: number } | null } };

export type AggregateProductOptionsImportSheetQueryVariables = Exact<{ [key: string]: never; }>;


export type AggregateProductOptionsImportSheetQuery = { __typename?: 'Query', aggregateProductOptionsImportSheet: { __typename?: 'AggregateProductOptionsImportSheet', _count?: { __typename?: 'ProductOptionsImportSheetCountAggregate', _all: number } | null } };

export type MaterialImportSheetRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaterialImportSheetRowOrderByWithRelationInput> | MaterialImportSheetRowOrderByWithRelationInput>;
}>;


export type MaterialImportSheetRowsQuery = { __typename?: 'Query', materialImportSheetRows: Array<{ __typename?: 'MaterialImportSheetRow', id: string, message?: string | null, status: BulkImportStatus, data: any, associatedMaterial?: { __typename?: 'Material', previewImageUrl: string, previewImageId: string, title: string } | null }> };

export type ProductOptionsImportSheetsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ProductOptionsImportSheetOrderByWithRelationInput> | ProductOptionsImportSheetOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductOptionsImportSheetsQuery = { __typename?: 'Query', productOptionsImportSheets: Array<{ __typename?: 'ProductOptionsImportSheet', id: string, status: ProductOptionsImportStatus, resultFile?: string | null }> };

export type MaterialsQueryVariables = Exact<{
  where?: InputMaybe<MaterialWhereInput>;
}>;


export type MaterialsQuery = { __typename?: 'Query', materials: Array<{ __typename?: 'Material', id: string, title: string, previewImageUrl: string }> };

export type DeleteOneMaterialImportSheetRowMutationVariables = Exact<{
  where: MaterialImportSheetRowWhereUniqueInput;
}>;


export type DeleteOneMaterialImportSheetRowMutation = { __typename?: 'Mutation', deleteOneMaterialImportSheetRow?: { __typename?: 'MaterialImportSheetRow', id: string, data: any } | null };

export type MaterialsForPriceSubGroupMutationQueryVariables = Exact<{ [key: string]: never; }>;


export type MaterialsForPriceSubGroupMutationQuery = { __typename?: 'Query', materials: Array<{ __typename?: 'Material', id: string, previewImageUrl: string }> };

export type UpdateProductVariantPriceMutationVariables = Exact<{
  data: Array<UpdateProductVariantPriceInput> | UpdateProductVariantPriceInput;
}>;


export type UpdateProductVariantPriceMutation = { __typename?: 'Mutation', updateProductVariantPrice: Array<{ __typename?: 'ProductVariant', compareAtPrice?: string | null, id: string, price: string }> };

export type ProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', adminGraphQlId: string, variantOptions: Array<{ __typename?: 'VariantOption', variantOptionName: string, id: string, priceGroups: Array<{ __typename?: 'PriceGroup', variantOptionValue: string, id: string, priceSubGroups: Array<{ __typename?: 'PriceSubGroup', url: string, title: string, description?: string | null, id: string, designer: string, composition: string, category: { __typename?: 'Category', materials: Array<{ __typename?: 'Material', id: string, previewImageUrl: string, title: string }> }, materials: Array<{ __typename?: 'Material', id: string, previewImageUrl: string, title: string }> }> }> }> }> };

export type PriceGroupCountQueryVariables = Exact<{
  where?: InputMaybe<PriceGroupWhereInput>;
}>;


export type PriceGroupCountQuery = { __typename?: 'Query', aggregatePriceGroup: { __typename?: 'AggregatePriceGroup', _count?: { __typename?: 'PriceGroupCountAggregate', _all: number } | null } };

export type UpdateOnePriceSubGroupMutationVariables = Exact<{
  data: PriceSubGroupUpdateWithShopifyInput;
  where: PriceSubGroupWhereUniqueIdInput;
}>;


export type UpdateOnePriceSubGroupMutation = { __typename?: 'Mutation', updateOnePriceSubGroup: { __typename?: 'PriceSubGroup', id: string, materialIds: Array<string>, designer: string, description?: string | null, title: string, url: string } };

export type CreateOneVariantOptionMutationVariables = Exact<{
  data: CreateVariantOptionWithShopifyDefinitionInput;
}>;


export type CreateOneVariantOptionMutation = { __typename?: 'Mutation', createOneVariantOption: { __typename?: 'VariantOption', id: string } };

export type CreateOnePriceSubGroupMutationVariables = Exact<{
  data: PriceSubGroupCreateWithShopifyInput;
}>;


export type CreateOnePriceSubGroupMutation = { __typename?: 'Mutation', createOnePriceSubGroup: { __typename?: 'PriceSubGroup', id: string, title: string } };

export type UpdateOneVariantOptionMutationVariables = Exact<{
  data: UpdateOneVariantOptionInput;
  where: VariantOptionWhereUniqueIdInput;
}>;


export type UpdateOneVariantOptionMutation = { __typename?: 'Mutation', updateOneVariantOption: { __typename?: 'VariantOption', id: string } };

export type CreateOnePriceGroupMutationVariables = Exact<{
  data: CreateOnePriceGroupWithShopifyDefinitionInput;
}>;


export type CreateOnePriceGroupMutation = { __typename?: 'Mutation', createOnePriceGroup: { __typename?: 'PriceGroup', id: string } };

export type UpdateOnePriceGroupMutationVariables = Exact<{
  data: UpdateOnePriceGroupInput;
  where: PriceGroupWhereUniqueInput;
}>;


export type UpdateOnePriceGroupMutation = { __typename?: 'Mutation', updateOnePriceGroup: { __typename?: 'PriceGroup', id: string } };


export const ShopifyProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShopifyProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reverse"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopifyProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"reverse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reverse"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queryResult"}}]}}]}}]} as unknown as DocumentNode<ShopifyProductsQuery, ShopifyProductsQueryVariables>;
export const MaterialsWithCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialsWithCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageId"}},{"kind":"Field","name":{"kind":"Name","value":"metaObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"Category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MaterialsWithCategoriesQuery, MaterialsWithCategoriesQueryVariables>;
export const CategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Categories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CategoriesQuery, CategoriesQueryVariables>;
export const CategoriesWithMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoriesWithMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designer"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"composition"}}]}}]}}]} as unknown as DocumentNode<CategoriesWithMaterialsQuery, CategoriesWithMaterialsQueryVariables>;
export const AllCategoriesByPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllCategoriesByPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"composition"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"designer"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AllCategoriesByPageQuery, AllCategoriesByPageQueryVariables>;
export const AggregateMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateMaterialQuery, AggregateMaterialQueryVariables>;
export const CreateOneMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialCreateWithShopifyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateOneMaterialMutation, CreateOneMaterialMutationVariables>;
export const UpdateMaterialWithShopifyDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaterialWithShopifyDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialUpdateWithShopifyDefinitionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}}]}}]}}]} as unknown as DocumentNode<UpdateMaterialWithShopifyDefinitionMutation, UpdateMaterialWithShopifyDefinitionMutationVariables>;
export const DeleteOneMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneMaterial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOneMaterialMutation, DeleteOneMaterialMutationVariables>;
export const CreateOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<CreateOneCategoryMutation, CreateOneCategoryMutationVariables>;
export const UpdateOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"composition"}},{"kind":"Field","name":{"kind":"Name","value":"designer"}},{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOneCategoryMutation, UpdateOneCategoryMutationVariables>;
export const CategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Category"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PriceSubGroup"}},{"kind":"Field","name":{"kind":"Name","value":"materials"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryQuery, CategoryQueryVariables>;
export const DeleteOneCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DeleteOneCategoryMutation, DeleteOneCategoryMutationVariables>;
export const DeleteOnePriceSubGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOnePriceSubGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceSubGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOnePriceSubGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DeleteOnePriceSubGroupMutation, DeleteOnePriceSubGroupMutationVariables>;
export const AggregateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateCategoryQuery, AggregateCategoryQueryVariables>;
export const _CountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"_count"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialImportSheetRowWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateMaterialImportSheetRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<_CountQuery, _CountQueryVariables>;
export const AggregateProductOptionsImportSheetSuccessfullyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateProductOptionsImportSheetSuccessfully"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOptionsImportSheetWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateProductOptionsImportSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateProductOptionsImportSheetSuccessfullyQuery, AggregateProductOptionsImportSheetSuccessfullyQueryVariables>;
export const AggregateMaterialImportSheetRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateMaterialImportSheetRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateMaterialImportSheetRow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateMaterialImportSheetRowQuery, AggregateMaterialImportSheetRowQueryVariables>;
export const AggregateProductOptionsImportSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateProductOptionsImportSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateProductOptionsImportSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateProductOptionsImportSheetQuery, AggregateProductOptionsImportSheetQueryVariables>;
export const MaterialImportSheetRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialImportSheetRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialImportSheetRowOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialImportSheetRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"associatedMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<MaterialImportSheetRowsQuery, MaterialImportSheetRowsQueryVariables>;
export const ProductOptionsImportSheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductOptionsImportSheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOptionsImportSheetOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productOptionsImportSheets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resultFile"}}]}}]}}]} as unknown as DocumentNode<ProductOptionsImportSheetsQuery, ProductOptionsImportSheetsQueryVariables>;
export const MaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Materials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]} as unknown as DocumentNode<MaterialsQuery, MaterialsQueryVariables>;
export const DeleteOneMaterialImportSheetRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneMaterialImportSheetRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialImportSheetRowWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneMaterialImportSheetRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<DeleteOneMaterialImportSheetRowMutation, DeleteOneMaterialImportSheetRowMutationVariables>;
export const MaterialsForPriceSubGroupMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialsForPriceSubGroupMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}}]}}]}}]} as unknown as DocumentNode<MaterialsForPriceSubGroupMutationQuery, MaterialsForPriceSubGroupMutationQueryVariables>;
export const UpdateProductVariantPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProductVariantPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductVariantPriceInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductVariantPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compareAtPrice"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<UpdateProductVariantPriceMutation, UpdateProductVariantPriceMutationVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminGraphQlId"}},{"kind":"Field","name":{"kind":"Name","value":"variantOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantOptionValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceSubGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designer"}},{"kind":"Field","name":{"kind":"Name","value":"composition"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"previewImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const PriceGroupCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"priceGroupCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatePriceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<PriceGroupCountQuery, PriceGroupCountQueryVariables>;
export const UpdateOnePriceSubGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOnePriceSubGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceSubGroupUpdateWithShopifyInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceSubGroupWhereUniqueIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOnePriceSubGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"materialIds"}},{"kind":"Field","name":{"kind":"Name","value":"designer"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UpdateOnePriceSubGroupMutation, UpdateOnePriceSubGroupMutationVariables>;
export const CreateOneVariantOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneVariantOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVariantOptionWithShopifyDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneVariantOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOneVariantOptionMutation, CreateOneVariantOptionMutationVariables>;
export const CreateOnePriceSubGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOnePriceSubGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceSubGroupCreateWithShopifyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOnePriceSubGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateOnePriceSubGroupMutation, CreateOnePriceSubGroupMutationVariables>;
export const UpdateOneVariantOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneVariantOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOneVariantOptionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VariantOptionWhereUniqueIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneVariantOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOneVariantOptionMutation, UpdateOneVariantOptionMutationVariables>;
export const CreateOnePriceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOnePriceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOnePriceGroupWithShopifyDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOnePriceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOnePriceGroupMutation, CreateOnePriceGroupMutationVariables>;
export const UpdateOnePriceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOnePriceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOnePriceGroupInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOnePriceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOnePriceGroupMutation, UpdateOnePriceGroupMutationVariables>;